<template>
  <div class="PeriodDatePicker">
    <div justify="center" align="center">
      <v-row justify="center" align="center" class="">
        <v-col justify="center" align="center" class="">
          <v-row class="pa-2">
            <v-col class="my-auto py-0" cols="6" xs6 sm="4" md="4">
              <v-select
                hide-details=""
                v-model="year"
                :items="years"
                :label="$t('year')"
                item-text="Name"
                item-value="Name"
                return-object
                dense
                outlined
                v-on:change="changeYear"
                class="my-auto py-0 px-1"
              ></v-select>
            </v-col>

            <v-col class="my-auto py-0" cols="6" xs6 sm="4" md="4">
              <v-select
                hide-details=""
                v-model="month"
                :items="months"
                :label="$t('period')"
                dense
                outlined
                @change="changeMonth"
                class="my-auto py-0 px-1"
              ></v-select>
            </v-col>

            <v-col
              cols="12"
              sm="4"
              md="4"
              justify="center"
              align="center"
              class="d-flex mt-2 mt-sm-0"
            >
              <v-btn
                class="mt-auto"
                block
                color="primary"
                @click="getResult()"
                >{{ $t("show") }}</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import EosToastType from "../../model/EosToastType";
export default {
  props: {
    getEosMonth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      year: {},
      month: "",
      years: [],
      months: [],
    };
  },
  mounted() {
    this.getYears();
  },
  methods: {
    getYears() {
      this.$store
        .dispatch("GetEosMonthlyYearsList")
        .then((result) => {
          if (result.type === "success") {
            var data = [];
            data = result.data;
            this.years = data;
            //this.year = data.slice(-1)[0];
            this.year = this.years[this.years.length - 1];
            this.changeYear();
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }
        })
        .catch((error) => {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: `${error}`,
          });
        });
      return [];
    },
    changeYear() {
      if (this.getEosMonth) {
        this.getPeriods();
      } else {
        this.getMonths();
      }
    },
    changeMonth() {
      this.getResult();
    },
    getMonths() {
      //debugger;
      this.months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
        var moment = require("jalali-moment");
       var nowMonth = moment().locale("fa").format("MM");
      //  this.month =parseInt(nowMonth.replace("0",""));
       this.month =parseInt(nowMonth.replace(/^0+/,""));
      // this.month = this.months[0];

      this.getResult();
    },
    getPeriods() {
      if (this.year == {}) {
        return;
      }
      //debugger;

      const params = new URLSearchParams();
      params.append("year", this.year.Name);

      this.$store
        .dispatch("GetEosMonthList", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            var data = [];
            data = result.data;
            //if (data.length > 0) {
            this.months = data;
            this.month = data.slice(-1)[0];
            // if (this.month) {

            //   var moment = require("jalali-moment");
            //   var nowMonth = moment().locale("fa").format("MM");
            //   nowMonth=parseInt(nowMonth.replace("0",""));
            //   let hasCurrentMount=data.includes(nowMonth);
            //   if(hasCurrentMount){
            //   this.months = data;
            //   this.month=nowMonth;
            //   }
            //   this.getResult();
            //   }

            if (this.month) {
              this.getResult();
            }
            //}
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error || "error",
            });
          }
        })
        .catch((error) => {
          this.$EosToast.show({
            type: EosToastType.error,
            msg: `${error}`,
          });
        });
      return [];
    },
    getResult() {
      //debugger;
      //  var moment = require("jalali-moment");
      //  var nowMonth = moment().locale("fa").format("MM");
      //  this.month =parseInt(nowMonth.replace("0",""));
      
      this.$emit("getDate", this.year.Name, this.month);
    },
  },
};
</script>

<style>
</style>